import $ from 'dom7';
import Framework7, { getDevice } from './framework7-custom.js';


// Import F7 Styles
import '../css/framework7-custom.less';
// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.less';
// Import Cordova APIs
import cordovaApp from './cordova-app.js';
// Import Routes
import routes from './routes.js';
// Import Store
import store from './store.js';

// Import main app component
// import App from '../app.f7.html';
// App for cashier

//import App from '../app_agent.f7.html';
//import App from '../app_cashier.f7.html';
//import App from '../app_kiosk.f7.html';
import App from '../app_web.f7.html';
//import App from '../app_check.f7.html';

//for android app store
window.playstore = false;
window.wap = false;

window.version   = "2.714";
window.uuid      = "undefined";
window.currency  = "USD";
window.lang      = "tl";  
window.waypoint  = window.atob("aHR0cHM6Ly9hcGkudGltb3I0ZC5jb20vanNvbi8=");


var device = getDevice();
var app = new Framework7({
  name: 'GD Lotaria', // App name
  theme: 'auto', // Automatic theme detection
  el: '#app', // App root element
  component: App, // App main component
  id: 'com.gd.global', // App bundle ID
  
  // App store
  store: store,
  // App routes
  routes: routes,

  // view:{
  //   browserHistory: true,
  // },

  // Input settings
  input: {
    scrollIntoViewOnFocus: device.cordova && !device.electron,
    scrollIntoViewCentered: device.cordova && !device.electron,
  },
  // Cordova Statusbar settings
  statusbar: {
    iosOverlaysWebView: true,
    androidOverlaysWebView: false,
  },
  on: {
    init: function () {
      var f7 = this;
      
      var username = localStorage.getItem("username");
      var password = localStorage.getItem("password");

      window.authbasic = window.btoa(username + ':' + password);

      

      console.log(window.service);

      if (f7.device.cordova) {
        // Init cordova APIs (see cordova-app.js)
        cordovaApp.init(f7);
      }

      window.country = `
      [
        {
          "code": "+670",
          "name": "TL",
          "id" : "TL"
        },
        {
          "code": "+62",
          "name": "ID",
          "id" : "ID"
        },
        {
          "code": "+60",
          "name": "MY",
          "id" : "MY"
        },
        {
          "code": "+66",
          "name": "TH"
          ,"id" : "TH"
        },
        {
          "code": "+63",
          "name": "PH"
          ,"id" : "PH"
        },
        {
          "code": "+86",
          "name": "CN"
          ,"id" : "CN"
        },
        {
          "code": "+1",
          "name": "Canada"
          ,"id" : ""
        },
        {
          "code": "+1",
          "name": "United States"
          ,"id" : ""
        },
        {
          "code": "+1 242",
          "name": "Bahamas"
          ,"id" : ""
        },
        {
          "code": "+1 246",
          "name": "Barbados"
          ,"id" : ""
        },
        {
          "code": "+1 264",
          "name": "Anguilla"
          ,"id" : ""
        },
        {
          "code": "+1 268",
          "name": "Antigua and Barbuda"
          ,"id" : ""
        },
        {
          "code": "+1 268",
          "name": "Barbuda"
          ,"id" : ""
        },
        {
          "code": "+1 284",
          "name": "British Virgin Islands"
          ,"id" : ""
        },
        {
          "code": "+1 340",
          "name": "U.S. Virgin Islands"
          ,"id" : ""
        },
        {
          "code": "+1 441",
          "name": "Bermuda"
          ,"id" : ""
        },
        {
          "code": "+1 473",
          "name": "Grenada"
          ,"id" : ""
        },
        {
          "code": "+1 649",
          "name": "Turks and Caicos Islands"
          ,"id" : ""
        },
        {
          "code": "+1 670",
          "name": "Northern Mariana Islands"
          ,"id" : ""
        },
        {
          "code": "+1 671",
          "name": "Guam"
          ,"id" : ""
        },
        {
          "code": "+1 684",
          "name": "American Samoa"
          ,"id" : ""
        },
        {
          "code": "+1 767",
          "name": "Dominica"
          ,"id" : ""
        },
        {
          "code": "+1 787",
          "name": "Puerto Rico"
          ,"id" : ""
        },
        {
          "code": "+1 808",
          "name": "Midway Island"
          ,"id" : ""
        },
        {
          "code": "+1 808",
          "name": "Wake Island"
          ,"id" : ""
        },
        {
          "code": "+1 809",
          "name": "Dominican Republic"
          ,"id" : ""
        },
        {
          "code": "+1 868",
          "name": "Trinidad and Tobago"
          ,"id" : ""
        },
        {
          "code": "+1 869",
          "name": "Nevis"
          ,"id" : ""
        },
        {
          "code": "+1 876",
          "name": "Jamaica"
          ,"id" : ""
        },
        {
          "code": "+1664",
          "name": "Montserrat"
          ,"id" : ""
        },
        {
          "code": "+20",
          "name": "Egypt"
          ,"id" : ""
        },
        {
          "code": "+212",
          "name": "Morocco"
          ,"id" : ""
        },
        {
          "code": "+213",
          "name": "Algeria"
          ,"id" : ""
        },
        {
          "code": "+216",
          "name": "Tunisia"
          ,"id" : ""
        },
        {
          "code": "+218",
          "name": "Libya"
          ,"id" : ""
        },
        {
          "code": "+220",
          "name": "Gambia"
          ,"id" : ""
        },
        {
          "code": "+221",
          "name": "Senegal"
          ,"id" : ""
        },
        {
          "code": "+222",
          "name": "Mauritania"
          ,"id" : ""
        },
        {
          "code": "+223",
          "name": "Mali"
          ,"id" : ""
        },
        {
          "code": "+224",
          "name": "Guinea"
          ,"id" : ""
        },
        {
          "code": "+225",
          "name": "Ivory Coast"
          ,"id" : ""
        },
        {
          "code": "+226",
          "name": "Burkina Faso"
          ,"id" : ""
        },
        {
          "code": "+227",
          "name": "Niger"
          ,"id" : ""
        },
        {
          "code": "+228",
          "name": "Togo"
          ,"id" : ""
        },
        {
          "code": "+229",
          "name": "Benin"
          ,"id" : ""
        },
        {
          "code": "+230",
          "name": "Mauritius"
          ,"id" : ""
        },
        {
          "code": "+231",
          "name": "Liberia"
          ,"id" : ""
        },
        {
          "code": "+232",
          "name": "Sierra Leone"
          ,"id" : ""
        },
        {
          "code": "+233",
          "name": "Ghana"
          ,"id" : ""
        },
        {
          "code": "+234",
          "name": "Nigeria"
          ,"id" : ""
        },
        {
          "code": "+235",
          "name": "Chad"
          ,"id" : ""
        },
        {
          "code": "+236",
          "name": "Central African Republic"
          ,"id" : ""
        },
        {
          "code": "+237",
          "name": "Cameroon"
          ,"id" : ""
        },
        {
          "code": "+238",
          "name": "Cape Verde"
          ,"id" : ""
        },
        {
          "code": "+240",
          "name": "Equatorial Guinea"
          ,"id" : ""
        },
        {
          "code": "+241",
          "name": "Gabon"
          ,"id" : ""
        },
        {
          "code": "+242",
          "name": "Congo"
          ,"id" : ""
        },
        {
          "code": "+243",
          "name": "Congo, Dem. Rep. of (Zaire)"
          ,"id" : ""
        },
        {
          "code": "+244",
          "name": "Angola"
          ,"id" : ""
        },
        {
          "code": "+245",
          "name": "Guinea-Bissau"
          ,"id" : ""
        },
        {
          "code": "+246",
          "name": "British Indian Ocean Territory"
          ,"id" : ""
        },
        {
          "code": "+246",
          "name": "Diego Garcia"
          ,"id" : ""
        },
        {
          "code": "+247",
          "name": "Ascension"
          ,"id" : ""
        },
        {
          "code": "+248",
          "name": "Seychelles"
          ,"id" : ""
        },
        {
          "code": "+249",
          "name": "Sudan"
          ,"id" : ""
        },
        {
          "code": "+250",
          "name": "Rwanda"
          ,"id" : ""
        },
        {
          "code": "+251",
          "name": "Ethiopia"
          ,"id" : ""
        },
        {
          "code": "+253",
          "name": "Djibouti"
          ,"id" : ""
        },
        {
          "code": "+254",
          "name": "Kenya"
          ,"id" : ""
        },
        {
          "code": "+255",
          "name": "Tanzania"
          ,"id" : ""
        },
        {
          "code": "+255",
          "name": "Zanzibar"
          ,"id" : ""
        },
        {
          "code": "+256",
          "name": "Uganda"
          ,"id" : ""
        },
        {
          "code": "+257",
          "name": "Burundi"
          ,"id" : ""
        },
        {
          "code": "+260",
          "name": "Zambia"
          ,"id" : ""
        },
        {
          "code": "+261",
          "name": "Madagascar"
          ,"id" : ""
        },
        {
          "code": "+262",
          "name": "Mayotte"
          ,"id" : ""
        },
        {
          "code": "+262",
          "name": "Reunion"
          ,"id" : ""
        },
        {
          "code": "+263",
          "name": "Zimbabwe"
          ,"id" : ""
        },
        {
          "code": "+264",
          "name": "Namibia"
          ,"id" : ""
        },
        {
          "code": "+265",
          "name": "Malawi"
          ,"id" : ""
        },
        {
          "code": "+266",
          "name": "Lesotho"
          ,"id" : ""
        },
        {
          "code": "+267",
          "name": "Botswana"
          ,"id" : ""
        },
        {
          "code": "+268",
          "name": "Swaziland"
          ,"id" : ""
        },
        {
          "code": "+269",
          "name": "Comoros"
          ,"id" : ""
        },
        {
          "code": "+27",
          "name": "South Africa"
          ,"id" : ""
        },
        {
          "code": "+291",
          "name": "Eritrea"
          ,"id" : ""
        },
        {
          "code": "+297",
          "name": "Aruba"
          ,"id" : ""
        },
        {
          "code": "+298",
          "name": "Faroe Islands"
          ,"id" : ""
        },
        {
          "code": "+299",
          "name": "Greenland"
          ,"id" : ""
        },
        {
          "code": "+30",
          "name": "Greece"
          ,"id" : ""
        },
        {
          "code": "+31",
          "name": "Netherlands"
          ,"id" : ""
        },
        {
          "code": "+32",
          "name": "Belgium"
          ,"id" : ""
        },
        {
          "code": "+33",
          "name": "France"
          ,"id" : ""
        },
        {
          "code": "+34",
          "name": "Spain"
          ,"id" : ""
        },
        {
          "code": "+345",
          "name": "Cayman Islands"
          ,"id" : ""
        },
        {
          "code": "+350",
          "name": "Gibraltar"
          ,"id" : ""
        },
        {
          "code": "+351",
          "name": "Portugal"
          ,"id" : ""
        },
        {
          "code": "+352",
          "name": "Luxembourg"
          ,"id" : ""
        },
        {
          "code": "+353",
          "name": "Ireland"
          ,"id" : ""
        },
        {
          "code": "+354",
          "name": "Iceland"
          ,"id" : ""
        },
        {
          "code": "+355",
          "name": "Albania"
          ,"id" : ""
        },
        {
          "code": "+356",
          "name": "Malta"
          ,"id" : ""
        },
        {
          "code": "+358",
          "name": "Finland"
          ,"id" : ""
        },
        {
          "code": "+359",
          "name": "Bulgaria"
          ,"id" : ""
        },
        {
          "code": "+36",
          "name": "Hungary"
          ,"id" : ""
        },
        {
          "code": "+370",
          "name": "Lithuania"
          ,"id" : ""
        },
        {
          "code": "+371",
          "name": "Latvia"
          ,"id" : ""
        },
        {
          "code": "+372",
          "name": "Estonia"
          ,"id" : ""
        },
        {
          "code": "+373",
          "name": "Moldova"
          ,"id" : ""
        },
        {
          "code": "+374",
          "name": "Armenia"
          ,"id" : ""
        },
        {
          "code": "+375",
          "name": "Belarus"
          ,"id" : ""
        },
        {
          "code": "+376",
          "name": "Andorra"
          ,"id" : ""
        },
        {
          "code": "+377",
          "name": "Monaco"
          ,"id" : ""
        },
        {
          "code": "+378",
          "name": "San Marino"
          ,"id" : ""
        },
        {
          "code": "+380",
          "name": "Ukraine"
          ,"id" : ""
        },
        {
          "code": "+381",
          "name": "Serbia"
          ,"id" : ""
        },
        {
          "code": "+382",
          "name": "Montenegro"
          ,"id" : ""
        },
        {
          "code": "+385",
          "name": "Croatia"
          ,"id" : ""
        },
        {
          "code": "+386",
          "name": "Slovenia"
          ,"id" : ""
        },
        {
          "code": "+387",
          "name": "Bosnia and Herzegovina"
          ,"id" : ""
        },
        {
          "code": "+389",
          "name": "Macedonia"
          ,"id" : ""
        },
        {
          "code": "+39",
          "name": "Italy"
          ,"id" : ""
        },
        {
          "code": "+40",
          "name": "Romania"
          ,"id" : ""
        },
        {
          "code": "+41",
          "name": "Switzerland"
          ,"id" : ""
        },
        {
          "code": "+420",
          "name": "Czech Republic"
          ,"id" : ""
        },
        {
          "code": "+421",
          "name": "Slovakia"
          ,"id" : ""
        },
        {
          "code": "+423",
          "name": "Liechtenstein"
          ,"id" : ""
        },
        {
          "code": "+43",
          "name": "Austria"
          ,"id" : ""
        },
        {
          "code": "+44",
          "name": "United Kingdom"
          ,"id" : ""
        },
        {
          "code": "+45",
          "name": "Denmark"
          ,"id" : ""
        },
        {
          "code": "+46",
          "name": "Sweden"
          ,"id" : ""
        },
        {
          "code": "+47",
          "name": "Norway"
          ,"id" : ""
        },
        {
          "code": "+48",
          "name": "Poland"
          ,"id" : ""
        },
        {
          "code": "+49",
          "name": "Germany"
          ,"id" : ""
        },
        {
          "code": "+500",
          "name": "Falkland Islands"
          ,"id" : ""
        },
        {
          "code": "+500",
          "name": "South Georgia and the South Sandwich Islands"
          ,"id" : ""
        },
        {
          "code": "+501",
          "name": "Belize"
          ,"id" : ""
        },
        {
          "code": "+502",
          "name": "Guatemala"
          ,"id" : ""
        },
        {
          "code": "+503",
          "name": "El Salvador"
          ,"id" : ""
        },
        {
          "code": "+504",
          "name": "Honduras"
          ,"id" : ""
        },
        {
          "code": "+505",
          "name": "Nicaragua"
          ,"id" : ""
        },
        {
          "code": "+506",
          "name": "Costa Rica"
          ,"id" : ""
        },
        {
          "code": "+507",
          "name": "Panama"
          ,"id" : ""
        },
        {
          "code": "+509",
          "name": "Haiti"
          ,"id" : ""
        },
        {
          "code": "+51",
          "name": "Peru"
          ,"id" : ""
        },
        {
          "code": "+52",
          "name": "Mexico"
          ,"id" : ""
        },
        {
          "code": "+53",
          "name": "Cuba"
          ,"id" : ""
        },
        {
          "code": "+537",
          "name": "Cyprus"
          ,"id" : ""
        },
        {
          "code": "+54",
          "name": "Argentina"
          ,"id" : ""
        },
        {
          "code": "+55",
          "name": "Brazil"
          ,"id" : ""
        },
        {
          "code": "+56",
          "name": "Chile"
          ,"id" : ""
        },
        {
          "code": "+56",
          "name": "Easter Island"
          ,"id" : ""
        },
        {
          "code": "+57",
          "name": "Colombia"
          ,"id" : ""
        },
        {
          "code": "+58",
          "name": "Venezuela"
          ,"id" : ""
        },
        {
          "code": "+590",
          "name": "Guadeloupe"
          ,"id" : ""
        },
        {
          "code": "+591",
          "name": "Bolivia"
          ,"id" : ""
        },
        {
          "code": "+593",
          "name": "Ecuador"
          ,"id" : ""
        },
        {
          "code": "+594",
          "name": "French Guiana"
          ,"id" : ""
        },
        {
          "code": "+595",
          "name": "Guyana"
          ,"id" : ""
        },
        {
          "code": "+595",
          "name": "Paraguay"
          ,"id" : ""
        },
        {
          "code": "+596",
          "name": "French Antilles"
          ,"id" : ""
        },
        {
          "code": "+596",
          "name": "Martinique"
          ,"id" : ""
        },
        {
          "code": "+597",
          "name": "Suriname"
          ,"id" : ""
        },
        {
          "code": "+598",
          "name": "Uruguay"
          ,"id" : ""
        },
        {
          "code": "+599",
          "name": "Curacao"
          ,"id" : ""
        },
        {
          "code": "+599",
          "name": "Netherlands Antilles"
          ,"id" : ""
        },
        {
          "code": "+61",
          "name": "Australia"
          ,"id" : ""
        },
        {
          "code": "+61",
          "name": "Christmas Island"
          ,"id" : ""
        },
        {
          "code": "+61",
          "name": "Cocos-Keeling Islands"
          ,"id" : ""
        },
        {
          "code": "+64",
          "name": "New Zealand"
          ,"id" : ""
        },
        {
          "code": "+65",
          "name": "Singapore"
          ,"id" : ""
        },
        {
          "code": "+672",
          "name": "Australian External Territories"
          ,"id" : ""
        },
        {
          "code": "+672",
          "name": "Norfolk Island"
          ,"id" : ""
        },
        {
          "code": "+673",
          "name": "Brunei"
          ,"id" : ""
        },
        {
          "code": "+674",
          "name": "Nauru"
          ,"id" : ""
        },
        {
          "code": "+675",
          "name": "Papua New Guinea"
          ,"id" : ""
        },
        {
          "code": "+676",
          "name": "Tonga"
          ,"id" : ""
        },
        {
          "code": "+677",
          "name": "Solomon Islands"
          ,"id" : ""
        },
        {
          "code": "+678",
          "name": "Vanuatu"
          ,"id" : ""
        },
        {
          "code": "+679",
          "name": "Fiji"
          ,"id" : ""
        },
        {
          "code": "+680",
          "name": "Palau"
          ,"id" : ""
        },
        {
          "code": "+681",
          "name": "Wallis and Futuna"
          ,"id" : ""
        },
        {
          "code": "+682",
          "name": "Cook Islands"
          ,"id" : ""
        },
        {
          "code": "+683",
          "name": "Niue"
          ,"id" : ""
        },
        {
          "code": "+685",
          "name": "Samoa"
          ,"id" : ""
        },
        {
          "code": "+686",
          "name": "Kiribati"
          ,"id" : ""
        },
        {
          "code": "+687",
          "name": "New Caledonia"
          ,"id" : ""
        },
        {
          "code": "+688",
          "name": "Tuvalu"
          ,"id" : ""
        },
        {
          "code": "+689",
          "name": "French Polynesia"
          ,"id" : ""
        },
        {
          "code": "+690",
          "name": "Tokelau"
          ,"id" : ""
        },
        {
          "code": "+691",
          "name": "Micronesia"
          ,"id" : ""
        },
        {
          "code": "+692",
          "name": "Marshall Islands"
          ,"id" : ""
        },
        {
          "code": "+7",
          "name": "Russia"
          ,"id" : ""
        },
        {
          "code": "+7 7",
          "name": "Kazakhstan"
          ,"id" : ""
        },
        {
          "code": "+7 840",
          "name": "Abkhazia"
          ,"id" : ""
        },
        {
          "code": "+81",
          "name": "Japan"
          ,"id" : ""
        },
        {
          "code": "+82",
          "name": "South Korea"
          ,"id" : ""
        },
        {
          "code": "+84",
          "name": "Vietnam"
          ,"id" : ""
        },
        {
          "code": "+850",
          "name": "North Korea"
          ,"id" : ""
        },
        {
          "code": "+852",
          "name": "Hong Kong SAR China"
          ,"id" : ""
        },
        {
          "code": "+853",
          "name": "Macau SAR China"
          ,"id" : ""
        },
        {
          "code": "+855",
          "name": "Cambodia"
          ,"id" : ""
        },
        {
          "code": "+856",
          "name": "Laos"
          ,"id" : ""
        },
        {
          "code": "+880",
          "name": "Bangladesh"
          ,"id" : ""
        },
        {
          "code": "+886",
          "name": "Taiwan"
          ,"id" : ""
        },
        {
          "code": "+90",
          "name": "Turkey"
          ,"id" : ""
        },
        {
          "code": "+91",
          "name": "India"
          ,"id" : ""
        },
        {
          "code": "+92",
          "name": "Pakistan"
          ,"id" : ""
        },
        {
          "code": "+93",
          "name": "Afghanistan"
          ,"id" : ""
        },
        {
          "code": "+94",
          "name": "Sri Lanka"
          ,"id" : ""
        },
        {
          "code": "+95",
          "name": "Myanmar"
          ,"id" : ""
        },
        {
          "code": "+960",
          "name": "Maldives"
          ,"id" : ""
        },
        {
          "code": "+961",
          "name": "Lebanon"
          ,"id" : ""
        },
        {
          "code": "+962",
          "name": "Jordan"
          ,"id" : ""
        },
        {
          "code": "+963",
          "name": "Syria"
          ,"id" : ""
        },
        {
          "code": "+964",
          "name": "Iraq"
          ,"id" : ""
        },
        {
          "code": "+965",
          "name": "Kuwait"
          ,"id" : ""
        },
        {
          "code": "+966",
          "name": "Saudi Arabia"
          ,"id" : ""
        },
        {
          "code": "+967",
          "name": "Yemen"
          ,"id" : ""
        },
        {
          "code": "+968",
          "name": "Oman"
          ,"id" : ""
        },
        {
          "code": "+970",
          "name": "Palestinian Territory"
          ,"id" : ""
        },
        {
          "code": "+971",
          "name": "United Arab Emirates"
          ,"id" : ""
        },
        {
          "code": "+972",
          "name": "Israel"
          ,"id" : ""
        },
        {
          "code": "+973",
          "name": "Bahrain"
          ,"id" : ""
        },
        {
          "code": "+974",
          "name": "Qatar"
          ,"id" : ""
        },
        {
          "code": "+975",
          "name": "Bhutan"
          ,"id" : ""
        },
        {
          "code": "+976",
          "name": "Mongolia"
          ,"id" : ""
        },
        {
          "code": "+977",
          "name": "Nepal"
          ,"id" : ""
        },
        {
          "code": "+98",
          "name": "Iran"
          ,"id" : ""
        },
        {
          "code": "+992",
          "name": "Tajikistan"
          ,"id" : ""
        },
        {
          "code": "+993",
          "name": "Turkmenistan"
          ,"id" : ""
        },
        {
          "code": "+994",
          "name": "Azerbaijan"
          ,"id" : ""
        },
        {
          "code": "+995",
          "name": "Georgia"
          ,"id" : ""
        },
        {
          "code": "+996",
          "name": "Kyrgyzstan"
          ,"id" : ""
        },
        {
          "code": "+998",
          "name": "Uzbekistan"
          ,"id" : ""
        }
      ]
      `;


    },
  },
});